//Style
import './FiltrosRelatorioMetas.css'

import { useEffect, useState } from "react";
import { get } from "../../services/api";
import { logout } from "../../auth";
import { useNavigate } from "react-router-dom";

import Select from 'react-select';
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';
import CustomMultiSelectGroup from '../CustomMultiSelectGroup/CustomMultiSelectGroup';

export default function FiltrosRelatorioMetas({ setMetas, setAnimais, setFiltros, setLoad, resetPage, setNumberOfPages, max }) {
    //Utils
    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';
    const [ authTokenState, setAuthTokenState ] = useState(null)
    const navigate = useNavigate()
    const selectStyle = { 
        control: (base, state) => ({
            ...base,
            background: "unset",
            borderColor: "#DCDCDC",
            borderRadius: "4px"
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }) 
    }
    const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    
    //Options
    const [ optionsTipo, setOptionsTipo ] = useState([]);
    const optionsMes = Array.from(
        { length: 12 }, 
        (_, index) => ({ label: nomeMeses[index], value: index + 1 })
    )
    const currentYear = new Date().getFullYear();
    const optionsAno = Array.from(
        { length: 2 + currentYear - 2023 }, 
        (_, index) => ({ label: 2023 + index, value: 2023 + index })
    )
    const [ optionsCluster, setOptionsCluster ] = useState([]);
    const [ optionsRegiao, setOptionsRegiao ] = useState([]);
    const [ optionsFilial, setOptionsFilial ] = useState([]);

    //Inputs
    const [ tipo, setTipo ] = useState(null);
    const [ mes, setMes ] = useState(null);
    const [ ano, setAno ] = useState({label: currentYear, value: currentYear});
    const [ regiao, setRegiao ] = useState(null);
    const [ cluster, setCluster ] = useState(null);
    const [ filial, setFilial ] = useState(null);

    //Populate Options
    async function setOptionsTipoWithRequest(authToken) {
        try {
            const optionsTipoData = await get('/admin/metas/tipo', null, authToken);       
            const options = optionsTipoData.map(tipo => ({ 
                label: tipo.descricao,
                value: tipo.id_tipo_metas
            }));
            setOptionsTipo(options);

            return optionsTipoData;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsClusterWithRequest(authToken) {
        try {
            const optionsClusterData = await get('/admin/metas/cluster', null, authToken);        
            const options = optionsClusterData.map(cluster => ({ 
                label: cluster.cluster, 
                value: cluster.id_cluster
            }));
            setOptionsCluster(options);

            return optionsClusterData;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const isSearchDisabled = ((cluster === null || cluster?.length === 0) 
            && (regiao === null || regiao?.length === 0) 
            && (filial === null || filial?.length === 0)
        )
        || tipo === null 
        || mes === null 
        || ano === null;

    async function setOptionsRegiaoWithRequest(authToken) {
        try {
            const optionsRegiaoData = await get('/admin/metas/regiao', null, authToken);         
            const options = optionsRegiaoData.map(regiao => ({ 
                label: regiao.nome_regiao, 
                value: regiao.id_regiao 
            }));
            setOptionsRegiao(options);

            return optionsRegiaoData;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsFilialWithRequest(authToken) {
        try {
            const optionsFilialData = await get('/admin/metas/filial', null, authToken);   
            const options = optionsFilialData;
            setOptionsFilial(options);

            return optionsFilialData;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        setAuthTokenState(authToken)
        
        setOptionsTipoWithRequest(authToken)
        setOptionsClusterWithRequest(authToken)
        setOptionsRegiaoWithRequest(authToken)
        setOptionsFilialWithRequest(authToken)
    }, [])

    //Utils
    function parseObjectToURLQuery(object) {
        return Object.keys(object).reduce(
            (accumulator, paramKey) => {
                if(object[paramKey]){
                    if(typeof object[paramKey] === 'object'){
                        return accumulator + object[paramKey].reduce((accumulator2, value) => accumulator2 + `&${paramKey}=${value}` , '')
                    }
                    else return accumulator + `&${paramKey}=${object[paramKey]}`
                }
                    
                else return accumulator
            }, '')
    }

    function formatarValoresFilial(valores) {
        if(Array.isArray(valores)){
            const filiais = optionsFilial
                                    .map(option => option.items)
                                    .flat()
                                    .map(filial => filial.value);
            
            const values = valores
                                .map(v => Number(v) + 10000)
                                .filter(v => !isNaN(v))
                                .filter(v => filiais.includes(v));
            
            return values;
        }
        return [];
    }

    //Actions
    function refreshInputs() {
        setTipo(null);
        setMes(null);
        setAno(new Date().getFullYear());
        setRegiao(null);
        setCluster(null);
        setFilial(null);
    }

    async function searchData() {
        try {
            const metasFiltros = {
                id_clusters: cluster,
                id_regioes: regiao,
                idfiliais: filial, 
                
                id_tipo_metas: tipo.value, 
                mes: mes.value, 
                ano: ano.value,

                page: 1,
                max: max
            };
            
            const metasResponse = await get(`/admin/metaspaginada?${parseObjectToURLQuery(metasFiltros)}`, null, authTokenState);

            setMetas(metasResponse.data);
            setNumberOfPages(metasResponse.numberOfPages);
            resetPage();

            const animaisFiltros = {
                id_tipo_metas: tipo.value,
                mes: mes.value,
                ano: ano.value
            };

            const animaisResponse = await get(`/admin/metas/animal?${parseObjectToURLQuery(animaisFiltros)}`, null, authTokenState);

            setAnimais(animaisResponse);

            setFiltros({
                id_clusters: cluster,
                id_regioes: regiao,
                idfiliais: filial, 
                
                id_tipo_metas: tipo.value, 
                mes: mes.value, 
                ano: ano.value
            })

            setLoad(true);

        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    
    return (
    <div className='relatorio-metas-first'>
        <div className='header'>
            <span>1</span>
            <h1>Selecione os filtros</h1>
        </div>
        <div className='body'>
            <div className='left-side'>
                <div className='tipo-wrapper'>
                    <label htmlFor="tipo">Selecione o tipo</label>
                    <Select
                        name="tipo"
                        className="react-select"
                        classNamePrefix="react-select"
                        value={tipo}
                        onChange={(tipo) => { 
                            setTipo(tipo);

                            setLoad(false);
                        }}
                        options={optionsTipo}
                        placeholder="Tipo"
                        required
                        isSearchable={false}
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                    />
                </div>

                <div className='periodo-wrapper'>
                    <div className='mes-wrapper'>
                        <label htmlFor="mes">Selecione o período</label>
                        <Select
                            name="mes"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={optionsMes}
                            value={mes}
                            onChange={mes => {
                                setMes(mes);

                                setLoad(false);
                            }}
                            placeholder="Mês"
                            required
                            menuPortalTarget={document.body}
                            styles={selectStyle}
                            isSearchable={false}
                            noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        />
                    </div>
                    <div className='ano-wrapper'>
                        <Select
                            name="ano"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={optionsAno}
                            value={ano}
                            onChange={ano => {
                                setAno(ano);

                                setLoad(false);
                            }}
                            required
                            menuPortalTarget={document.body}
                            styles={selectStyle}
                            isSearchable={false}
                            noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        />
                    </div>
                </div>
            </div>
            <div className='right-side'>
                <div className='cluster-wrapper'>
                    <label htmlFor="cluster">Selecione o cluster</label>
                    <CustomMultiSelect
                        selectedOptions={cluster}
                        setSelectedOptions={setCluster}
                        filteredOptions={optionsCluster}
                        placeholder={'Cluster'}
                        disabled={
                            (regiao != null && regiao?.length > 0) || 
                            (filial != null && filial?.length > 0)
                        }
                        onChange={() => setLoad(false)}
                    />
                </div>

                <span>ou</span>

                <div className='regiao-wrapper'>
                    <label htmlFor="regiao">Selecione a região</label>
                    <CustomMultiSelect
                        selectedOptions={regiao}
                        setSelectedOptions={setRegiao}
                        filteredOptions={optionsRegiao}
                        placeholder='Região'
                        disabled={
                            (cluster != null && cluster?.length > 0) || 
                            (filial != null && filial?.length > 0) 
                        }
                        onChange={() => setLoad(false)}
                    />
                </div>

                <span>ou</span>

                <div className='filial-wrapper'>
                    <label htmlFor="filial">Selecione as filiais</label>
                    <CustomMultiSelectGroup
                        options={optionsFilial}
                        placeholder="Filiais"
                        selectedOptions={filial}
                        setSelectedOptions={setFilial}
                        className='input-idfiliais'
                        disabled={
                            (cluster != null && cluster?.length > 0) || 
                            (regiao != null && regiao?.length > 0)
                        }
                        doOnChange={() => setLoad(false)}
                        formatValuesOnFill={formatarValoresFilial}
                    />
                </div>

                <div className="manage-btns">
                    <button 
                        className="refresh-btn" 
                        onClick={refreshInputs}
                        disabled={isSearchDisabled}>Limpar</button>
                    <button 
                        className="search-btn" 
                        onClick={searchData}
                        disabled={isSearchDisabled}>Carregar</button>
                </div>
            </div>
        </div>
    </div>
    )
}